module.exports = __webpack_public_path__ + "static/media/curve-demo.51a4ddd9.mp4";